import {StatisticsCounter} from './StatisticsCounter';
export default StatisticsCounter;
